// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"P_TheComp___M2hT"};